import { SYNC_KEY_PROYECTOS_COSECHAS } from "../../../constantes";
import { CosechaProyectoItem, ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { CosechaEstado, CosechaResponse } from "../../../shared/response/proyectos/CosechaResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Cosechas (temporadas con tasa IPC base + ajuste por categoría) (`ProyectosPlataformaService`, gRPC). */
export class CosechaService extends ServiceGetListBase<CosechaResponse> {
  static readonly instance = new CosechaService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_COSECHAS;
  protected readonly sortBy = "nombre";

  /** gRPC-Web (`ListCosechas`): no eliminadas, con sus tasas por categoría y sus totales. */
  protected async fetchItems(): Promise<CosechaResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listCosechas({}));
    return r.items.map(toCosechaResponse);
  }

  /** Congela las tasas IPC de la cosecha (`ActivarCosecha`). A partir de ahí no se pueden editar. */
  async activar(id: string): Promise<CosechaResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).activarCosecha({ id }));
    const item = toCosechaResponse(r);
    this.upsert(item);
    return item;
  }

  /** Marca esta cosecha como la vigente (`MarcarCosechaVigente`, exclusiva): la que fija el precio del catálogo ahora mismo. */
  async marcarVigente(id: string): Promise<CosechaResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).marcarCosechaVigente({ id }));
    const item = toCosechaResponse(r);
    this.upsert(item);
    return item;
  }
}

/** Mensaje gRPC de la cosecha → `CosechaResponse` (fechas Unix ms → ISO). Lo reusa el guardado. */
export function toCosechaResponse(c: CosechaProyectoItem): CosechaResponse {
  return {
    id: c.id,
    isEliminado: false,
    nombre: c.nombre,
    anio: c.anio,
    tasaBaseIpc: c.tasaBaseIpc,
    frozen: c.frozen,
    vigente: c.vigente,
    // El contrato no la trae: ninguna pantalla la muestra.
    fechaCongelacion: null,
    fechaInicioVigencia: c.fechaInicioVigencia !== undefined ? new Date(Number(c.fechaInicioVigencia)).toISOString() : null,
    fechaFinVigencia: c.fechaFinVigencia !== undefined ? new Date(Number(c.fechaFinVigencia)).toISOString() : null,
    estado: c.estado as CosechaEstado,
    tasasPorCategoria: c.tasasPorCategoria.map((t) => ({ id: t.id, categoria: t.categoria, tasa: t.tasa, override: t.override })),
    totalMacroProyectos: c.totalMacroProyectos,
    totalProyectos: c.totalProyectos,
  };
}
